import { Middleware } from '@nuxt/types'
import { ApplicationResource } from '~/store/applications/applications/applications.types'

const applicationForm: Middleware = async ({ app, redirect, store, route }) => {
  let { path } = route

  // Remove trailing slash
  if (path.charAt(path.length - 1) === '/') {
    path = path.slice(0, path.length - 1)
  }

  if (!path.includes('/apply')) {
    return
  }

  const { currentUser } = store.getters

  if (!currentUser) {
    return redirect(app.localePath('account-create'))
  }

  if (!currentUser.membership.nonMemberAccount) {
    return redirect(app.localePath('index'))
  }

  // Due to users that may still be in session without a cookie containing a token,
  // This will set the cookie, log them in and then redirect back to the page they were on
  const bouncerSession = app.$cookies.get('bouncerSession')

  if (!bouncerSession) {
    const { accessToken } = store.state.oauth
    // @ts-ignore Typescript thinks $cookies.set only takes one argument, when it takes two
    app.$cookies.set('bouncerSession', accessToken)
    return app.$login(path)
  }

  await store.dispatch('applications/applications/fetchApplications')

  const application = store.getters['applications/applications/applications'][0]
  const applyPage = app.localePath('apply')

  if (application && path === applyPage) {
    const packagePage = app.localePath({ name: 'apply-id-package', params: { id: application.id }})

    // TODO: Redirect based on completeness
    return redirect(packagePage)
  }

  if (!application && path !== applyPage) {
    // They haven't started an application - take them to the start
    return redirect(applyPage)
  }

  return
}

export default applicationForm
